// extracted by mini-css-extract-plugin
module.exports = {"form":"SigningForm_form__1OD0H"};